/** Cart lines -> vendor line payload. Add-ons are their own lines under
 * serviceID 13 and ride the same order as their boat. We never send an amount:
 * the vendor re-prices at both quote and booking. */
export const toVendorLines = (lines) =>
  lines.flatMap((l) => [
    {
      assetId: l.assetId,
      serviceId: l.serviceId,
      priceId: l.priceId,
      quantity: l.quantity,
      label: `${l.displayName} for ${l.tierLabel}`,
      startDateTime: l.startDateTime,
      endDateTime: l.endDateTime,
    },
    ...(l.addons || []).map((a) => ({
      assetId: a.assetId,
      serviceId: a.serviceId,
      priceId: a.priceId,
      quantity: a.quantity,
      label: a.label,
      startDateTime: l.startDateTime,
      endDateTime: l.endDateTime,
    })),
  ]);

export const addonTotal = (line) =>
  (line.addons || []).reduce((sum, a) => sum + (a.amount || 0) * (a.quantity || 1), 0);
